import { render } from "./App.vue?vue&type=template&id=e22366ea"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e22366ea&lang=css"
script.render = render

export default script